import m from "../../es2015/lang/nb_NO";
window.am4lang_nb_NO = m;


//////////////////
// WEBPACK FOOTER
// ./lang/nb_NO.js
// module id = null
// module chunks = 